import React from "react";
import { Route, Link, withRouter } from "react-router-dom";
import UserAvatar from "../photographers/photograher_avatar";
import {formatDatetime} from "../../util/date_util";

class OrderSummaryComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }


  componentDidMount() {
  }

  openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  render() {
    let price = 0;
    let discount = 0;
    let button = <button className="projectEditButton projectEditButtonPrimary" onClick={() => this.props.previewOrder(discount, promoPrice, promoName)}>Submit Changes</button>
    let account_credit_component = "";
    let account_credit = this.props.account_credit;

    let promoPrice = null
    let promoName = ""
    let previous_services = {}
    // let package_attributes_without_reshoot = Object.values(this.props.package_attributes).filter(pack => !this.props.services[pack.service_id].reshoot)
    let package_attributes_without_reshoot = Object.values(Object.keys(this.props.package_attributes).filter((key) => this.props.services[key] && !this.props.services[key].reshoot).reduce((cur, key) => { return Object.assign(cur, { [key]: this.props.package_attributes[key] }) }, {}))

    this.props.previous_services.forEach(service => previous_services[service.id] = true)

    if (this.props.promos.length > 0) {
      this.props.promos.forEach(promo => {
        if (this.props.package_attributes[promo.service.id]) {
          if (promo.services.length > 0) {
            promo.services.forEach(service => {
              if (this.props.package_attributes[service.id] && package_attributes_without_reshoot.length === 2) {
                promoPrice = parseInt(promo.price)
                promoName = promo.name
              }
            })
          } else {
            if (package_attributes_without_reshoot.length === 1) {
              promoPrice = parseInt(promo.price)
              promoName = promo.name
            }
          }
        }
      })
    }


    const isAdmin = this.props.currentUser?.roles?.admin
    const existingSavingsDelta = this.props.existing_savings_delta || 0
    const previousSubservices = this.props.previousSubservices || {}
    const newSubservices = Object.values(this.props.subservices).filter(ss => !previousSubservices[ss.id])
    const baseSavingsPerSub = (!isAdmin && existingSavingsDelta > 0 && newSubservices.length > 0)
      ? Math.floor(existingSavingsDelta / newSubservices.length)
      : 0
    const remainder = (!isAdmin && newSubservices.length > 0) ? existingSavingsDelta - baseSavingsPerSub * newSubservices.length : 0

    const rawPriceSum = newSubservices.reduce((sum, ss) => {
      return sum + parseFloat(this.props.location_pricing[ss.id] ? this.props.location_pricing[ss.id].price : ss.price)
    }, 0)
    const targetBundleAdjustedSum = this.props.bundle_discounted
      ? rawPriceSum - rawPriceSum * this.props.bundle_discounted / 100
      : rawPriceSum

    const discountCode = this.props.discount_code

    // Pre-compute coupon ratio for non-admin so it can be folded into per-service display prices
    let couponRatio = 1
    if (!isAdmin && discountCode) {
      const priceBeforeMap = this.props.bundle_discounted ? targetBundleAdjustedSum : rawPriceSum
      if (priceBeforeMap > 0) {
        let codeDiscount = discountCode.percentage
          ? priceBeforeMap * discountCode.amount / 100.0
          : Math.min(discountCode.amount, priceBeforeMap)
        if (codeDiscount > 0) {
          couponRatio = Math.round(priceBeforeMap - codeDiscount) / priceBeforeMap
        }
      }
    }

    let newSubIndex = 0
    let bundleAdjustedAccum = 0
    let subServices = Object.values(this.props.subservices).map(subservice => {
      if (previousSubservices[subservice.id]) return ""

      const rawPrice = parseFloat(this.props.location_pricing[subservice.id] ? this.props.location_pricing[subservice.id].price : subservice.price)
      const isLastNew = newSubIndex === newSubservices.length - 1
      const bundleAdjustedForDisplay = this.props.bundle_discounted
        ? (isLastNew ? targetBundleAdjustedSum - bundleAdjustedAccum : Math.round(rawPrice - rawPrice * this.props.bundle_discounted / 100))
        : rawPrice
      const savingsForThis = baseSavingsPerSub + (isLastNew ? remainder : 0)
      const couponAdjustedForDisplay = !isAdmin ? Math.round(bundleAdjustedForDisplay * couponRatio) : bundleAdjustedForDisplay
      const finalDisplayPrice = couponAdjustedForDisplay - savingsForThis

      price += rawPrice
      bundleAdjustedAccum += bundleAdjustedForDisplay
      newSubIndex++

      return (<div className="orderSummaryLi">
        <div>{this.props.services[subservice.service_id]?.title} - {subservice.title}</div>
        <div style={{display: "flex"}}>
          {this.props.new_update_process && <div className="orderSummarySubservicePrice">${finalDisplayPrice.toFixed(0)}</div>}
          {this.props.checkout ? <div className="itemIcon3" onClick={() => this.props.changeParentState({ page: 2, specific_service: subservice.service_id, selected_service: subservice.service_id })}><i className="fas fa-edit settingsServiceIcon m-2"></i></div> : ""}
          <div className="itemIcon" onClick={() => this.props.deleteSubService(subservice)}><i className="far fa-trash-alt settingsServiceIcon m-2"></i></div>
        </div>
      </div>)
    })

    if (this.props.bundle_discounted){
      price = price - price * this.props.bundle_discounted / 100
    }

    if (discountCode && price > 0) {
      let codeDiscount = 0
      if (discountCode.percentage) {
        codeDiscount = price * discountCode.amount / 100.0
      } else {
        codeDiscount = Math.min(discountCode.amount, price)
      }
      if (codeDiscount > 0) {
        const newPrice = Math.round(price - codeDiscount)
        if (isAdmin) {
          const displayDiscount = price - newPrice
          subServices.push(<div className="orderSummaryLi">
            <div>Discount code applied:</div>
            <div className="orderSummarySubservicePrice promoApplied">-${displayDiscount.toFixed(0)}</div>
          </div>)
        }
        price = newPrice
      }
    }

    price = Math.round(price)

    if (existingSavingsDelta > 0) {
      if (isAdmin) {
        subServices.push(<div className="orderSummaryLi">
          <div>Additional bundle savings on existing services:</div>
          <div className="orderSummarySubservicePrice promoApplied">-${existingSavingsDelta.toFixed(0)}</div>
        </div>)
      }
      price -= existingSavingsDelta
    }

    if (promoPrice) {
      let promo_discount = price - (promoPrice - parseInt(this.props.previous_total))
      subServices.push(<div className="orderSummaryLi">
        <div>{promoName} Promo Applied: </div>
        <div className="orderSummarySubservicePrice promoApplied">{promo_discount > 0 ? "-" : ""}${Math.abs(promo_discount).toFixed(0)}</div>
      </div>)

      price = promoPrice - parseInt(this.props.previous_total)
    }

    if (this.props.account_credit && price > 0) {
      if (this.props.account_credit >= price) {
        account_credit = this.props.account_credit - price
        price = 0
        discount = this.props.account_credit - account_credit
      } else {
        price = price - this.props.account_credit
        discount = this.props.account_credit
        account_credit = 0
      }
    }

    if (discount > 0) {
      subServices.push(<div className="orderSummaryLi">
        <div>Account credit applied: </div>
        <div className="orderSummarySubservicePrice promoApplied">-${discount.toFixed(0)}</div>
      </div>)
    }

    if (account_credit > 0) {
      account_credit_component = <div className="">
        <div className="totalOrderSummaryDiv">Account Credit:</div>
        <div className="totalOrderSummaryPrice">$ {account_credit.toFixed(0)}</div>
      </div>
    }

    let photographer_appointment_groupings = {}

    const newServiceIds = new Set(newSubservices.map(ss => String(ss.service_id)))
    let photographersLis = Object.values(this.props.appointments).filter(appointment => newServiceIds.has(String(appointment.service_id))).map(appointment => {
      if (!photographer_appointment_groupings[`${appointment.contractor.id}-${appointment.appointment_time}`]) {
        photographer_appointment_groupings[`${appointment.contractor.id}-${appointment.appointment_time}`] = true
        let appointment_services = `${this.props.services[appointment.service_id].title}`
        Object.values(this.props.appointments).filter(appointment => newServiceIds.has(String(appointment.service_id))).filter(other_appointment => other_appointment.contractor.id === appointment.contractor.id && other_appointment.appointment_time === appointment.appointment_time && appointment.service_id != other_appointment.service_id).forEach(current_appointment => {
          appointment_services += `, ${this.props.services[current_appointment.service_id].title}`
        })
        return <div className="orderSummaryPhotographerLi">
          <UserAvatar user={appointment.contractor} />
          <div className="contractorNameAndAppointment">
            <div>{appointment.contractor.firstName} {appointment.contractor.lastName[0]}</div>
            <div>{appointment_services}</div>
            <div>{formatDatetime(appointment.appointment_time, null, this.props.detected_timezone)}</div>
            {this.props.checkout ? <div className="changeAppointmentText" onClick={() => this.props.changeParentState({ page: 4, selected_service: appointment.service_id })}>Change Date/Time</div> : ""}
          </div>
        </div>
      }
    })

    if (photographersLis.length === 0) {
      photographersLis =
        <div className="noServicesSelected">
          <div>No selected photographers</div>
        </div>
    }

    let errors = []

    this.props.errors?.forEach((error) => {
      errors.push(<li>{error}</li>)
    })

    let checkout = ""

    if (this.props.checkout) {
      checkout = "checkoutStyle"
    }

    return (
      <div id={checkout} className="orderSummaryComponent">
        <div className="settingsComponentHeader">
          <div className="settingsComponentHeading">Check Out</div>
          <div className="settingsComponentDescription" id="add_service_order_summary_sub_heading">
            Below is a list of your added services
          </div>
        </div>
        <div className="subServicesList">
          {subServices}
          {this.props.checkout ? <div className="addMoreServicesText" onClick={() => this.props.changeParentState({ page: 2, errors: [], selected_service: -1, specific_service: -1 })}>Add More Services</div> : ""}
        </div>
        <div className="settingsComponentHeading">Photographers</div>
        <div className="photographersList">
          {photographersLis}
        </div>
        <div className="orderSummaryPriceDiv">
          <div>Change in cost: </div>
          <div>${price.toFixed(0)}</div>
        </div>
        {/* {account_credit_component} */}
        <ul className="backendErrorUl">{errors}</ul>
      </div>
    )
  }
}

export default withRouter(OrderSummaryComponent);